export const ruTranslation = {
  "access": {
    "accessibility_settings": "Настройки доступности",
    "internet_accessibility": "Интернет-доступность означает, что люди с ограниченными возможностями могут использовать интернет",
    "contrast": "Контрастность",
    "dark": "Темный",
    "normal": "Обычный",
    "bright": "Светлый",
    "color": "Цвет",
    "high": "Высокий",
    "black_white": "Черно-белый",
    "font_size": "Размер шрифта",
    "clear_selection": "Очистить выбор"
  },
  "cookie": {
    "cookie_policy": "Политика использования файлов cookie",
    "title": "Мы ценим вашу конфиденциальность.",
    "text": "Мы используем файлы cookie для улучшения вашего опыта веб-сёрфинга, предоставления персонализированных рекламных или контентных материалов и анализа нашего трафика. Нажав на «Принять все», вы соглашаетесь с использованием наших файлов cookie.",
    "accept": "Принять все",
    "reject": "Отклонить все"
  }
};
